import React from 'react';
import { render } from 'react-dom';

import App from './components/app/App.component';

render(<App />, document.getElementById('app'));
